import { combineReducers } from "redux";
import projectsList from "./projectsList";
import currentProject from "./currentProject";

const projectsReducer = combineReducers({
  projectsList,
  currentProject
});

export default projectsReducer;